import angular from "angular";

const contactUs = function ($resource) {
  'ngInject';

  return $resource('/api/v1/fo/service-provider/contact-us', {}, {
    send: {
      method: "POST",
      isArray: false
    }
  })
}

export default angular.module('vt-service-provider-resource.contact-us', [])
  .service('ServiceProviderContactUsApi', contactUs);
